import React from 'react';
import { withStyles, BodyText } from 'vopay';
import styles from './DetailsRows.module.scss';

const classes = withStyles(styles);

export interface DetailsRowItem {
  label: React.ReactNode;
  value: React.ReactNode;
  visible?: boolean;
}

type DetailsRowsProps = {
  details: DetailsRowItem[];
};

export default function DetailsRows({ details }: DetailsRowsProps) {
  if (details.length === 0) {
    return null;
  }

  return (
    <div className={classes('detailsContainer')}>
      {details
        .filter(({ visible = true }) => visible)
        .map((detail, index) => (
          <div key={index} className={classes('detailRow')}>
            <BodyText weight="md">{detail.label}</BodyText>
            <BodyText className={classes('detailValue')}>{detail.value}</BodyText>
          </div>
        ))}
    </div>
  );
}
